<template>
  <div>
    <ExportDropDown
      :bottomAlign="isLastItem"
      :class="$style.exportContainer"
      :disabled="disableExport"
      :errorMessage="errorMessage"
      :exportFunction="handleExport"
      :successMessage="successMessage"
    />
  </div>
</template>

<script>
import {
  ReportStatusConsts, baseUrl, exportFailureMessage, exportSuccessMessage,
} from 'Reports/constants/reportsConstants';
import { find } from 'lodash';
import DownloadUtil from 'client/util/DownloadUtil';
import ExportDropDown from 'components/DropDownMenu/ExportDropDown.vue';
import MspState from 'client/components/models/MspState';
import ReportsApi from 'client/api/v2/ReportsApi';
import Util from 'client/util/Util';

const { redirect } = Util;
export default {
  name: 'DownloadReportLink',

  components: {
    ExportDropDown,
  },

  props: {
    index: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      required: true,
    },
    totalItemCount: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    errorMessage: exportFailureMessage,
    successMessage: exportSuccessMessage,
  }),

  computed: {
    disableExport() {
      return this.item.status !== ReportStatusConsts.completed;
    },
    isLastItem() {
      return this.totalItemCount - 1 === this.index;
    },
  },

  methods: {
    handleExport(fileType) {
      const artifactObjectId = find(this.item.artifacts, { format: fileType.toUpperCase() }).id;

      // if it is not an MSP user, use the redirect download elase use the RPC download method
      // the redirect method will not work for MSP users because their cookie is not
      // bound to an org-id
      if (!MspState.isAnMsp) {
        redirect(`${baseUrl}/${this.item.id}/artifacts/${artifactObjectId}/content`);
      } else {
        ReportsApi.downloadReport(this.item.id, artifactObjectId)
          .then((resp) => {
            const fileName = resp.headers['content-disposition'].split('"')[1];
            if (fileName.includes('csv')) {
              DownloadUtil.downloadFile(resp.data, fileName);
            } else {
              DownloadUtil.downloadJson(resp.data, fileName);
            }
          });
      }
    },
  },
};
</script>
<style scoped module>
  .exportContainer {
    padding-right: 10px;
  }
</style>
